import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '@/store/hooks.ts';
import { setActiveColorCategory } from '@/store/slices/transmissionReports/transmissionReportsSlice.ts';
import { useGetDefaultReportId } from '@/hooks/useGetFirstReportId.ts';
import { routes } from '@/routes';

import LoadingPage from '@/pages/common/LoadingPage';

export const TransmissionReportRedirectPage = () => {
  const { data, error, isSuccess, isLoading } = useGetDefaultReportId();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // If there is a reportId, navigate to the report detail page
    if (data?.transmissionReportId && data?.color) {
      dispatch(setActiveColorCategory({ color: data.color }));
      navigate(routes.physician.transmissionReportDetail(data.transmissionReportId.toString()), {
        replace: true
      });
    }

    // If there are no reports, navigate to the dashboard
    if (isSuccess && !isLoading && data && !data?.transmissionReportId) {
      navigate(routes.physician.dashboard);
    }

    if (error) {
      navigate(routes.physician.dashboard);
    }
  }, [data, dispatch, isSuccess, error, navigate, isLoading]);

  return <LoadingPage title={`Redirecting`} message="Redirecting to the transmission report..." />;
};
